import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './BookingLocation.scss';
import { locationApi } from '~/api';
import { BookingContext, bookingClassNameModifier } from '../booking.context';
import { MapImage } from './map-image';

export class BookingAddress extends PureComponent {
  state = {
    mapImage: undefined,
  };

  componentDidMount() {
    const { width, height, address } = this.props;

    locationApi
      .getMapImage({
        query: address,
        width,
        height,
      })
      .then((image) => {
        this.setState({ mapImage: image });
      });
  }

  render() {
    const { mapImage } = this.state;
    const { address } = this.props;
    return (
      <BookingContext.Consumer>
        {(context) => (
          <div
            className={`${styles[`${bookingClassNameModifier(context)}BookingReview__location`]} sessioncamhidemap`}
            data-testid="appointmentLocation"
          >
            <MapImage imageSrc={mapImage} searchQuery={address} />
            <div>
              <h5>Your home address</h5>
              <address className="sessioncamhidetext">{address}</address>
            </div>
          </div>
        )}
      </BookingContext.Consumer>
    );
  }
}

BookingAddress.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  address: PropTypes.string.isRequired,
};

BookingAddress.defaultProps = {
  width: 400,
  height: 400,
};
